import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth.jsx";

export default function Layout() {
    const { me, logout } = useAuth();
    const navigate = useNavigate();

    async function doLogout() {
        await logout();
        navigate("/login", { replace: true });
    }

    const link = ({ isActive }) => "nav" + (isActive ? " active" : "");

    return (
        <div className="app">
            <aside className="sidebar">
                <div className="brand">UxTelemetry <small>v2</small></div>

                <div className="nav-section">Reports</div>
                <NavLink to="/"           end className={link}>Overview</NavLink>
                <NavLink to="/sessions"      className={link}>Sessions</NavLink>
                <NavLink to="/attempts"      className={link}>Attempts</NavLink>
                <NavLink to="/bans"          className={link}>Bans</NavLink>
                <NavLink to="/hwid-bans"     className={link}>HWID bans</NavLink>
                <NavLink to="/hwid-log"      className={link}>HWID log</NavLink>
                <NavLink to="/kernel-failures" className={link}>Kernel failures</NavLink>

                <div className="nav-section">Account</div>
                <NavLink to="/config"        className={link}>Detection rules</NavLink>
                <NavLink to="/settings"      className={link}>Settings &amp; API key</NavLink>

                {me?.role === "super" && (
                    <>
                        <div className="nav-section">Super-admin</div>
                        <NavLink to="/admins"        className={link}>Admins</NavLink>
                        <NavLink to="/admin-logins"  className={link}>Login audit</NavLink>
                    </>
                )}

                <div className="nav-bottom">
                    <div className="me">
                        <div>
                            <span className="user">{me?.username}</span>
                            <span className={"pill role" + (me?.role === "super" ? " super" : "")}>
                                {me?.role}
                            </span>
                        </div>
                    </div>
                    <button className="ghost" style={{ width: "100%" }} onClick={doLogout}>Log out</button>
                </div>
            </aside>
            <main className="main">
                <Outlet />
            </main>
        </div>
    );
}
